import React from "react";

import NameTemplate from "../NameTemplate/NameTemplate";
import DateTemplate from "../DateTemplate/DateTemplate";
import PositionTemplate from "../PositionTemplate/PositionTemplate";
import BiographyTemplate from "../BiographyTemplate/BiographyTemplate";

import { Hero } from "../Constants";

import AudioPlayer from "../AudioPlayer/AudioPlayer";

import { Link, useParams } from "react-router-dom";

import Logo from "../Logo/Logo";
import GloryTemplate from "../GloryTemplate/GloryTemplate";

import Slider from "../Slider/Slider";

import "./style.css";
import Button from "../Button/Button";

import printBg from "./Images/print-bg.png";

const Page1 = () => {
  const { id } = useParams();

  const selectedHero = Hero.find((hero) => hero.id === +id);

  if (!selectedHero) {
    return null;
  }

  const nameParts = selectedHero.name.split(" ");
const firstLine = nameParts.slice(0, 2).join(" "); // ім'я + по батькові
const surname = nameParts.slice(2).join(" ");  

  return (
    <section className="victim">
      {/* ===== Звичайна сторінка ===== */}
      <div className="victim__screen">
        <div className="victim__container">
          <div className="logo">
            <Logo />
          </div>

          <div className="victim__content">
            <div className="victim__img">
              <img
                className="img"
                src={selectedHero.photo}
                alt={selectedHero.name}
              />
            </div>
            <div className="victim__description">
              <NameTemplate text={selectedHero.name} />
              <DateTemplate text={selectedHero.date} />
              <h2 className="victim__life">Віддав життя за Україну</h2>
              <PositionTemplate text={selectedHero.position} />
              {selectedHero.audio && <AudioPlayer src={selectedHero.audio} />}
            </div>
          </div>

          <BiographyTemplate text="Життєпис" />
          <div className="victim__text">
            {Object.values(selectedHero.texts).map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>

          {selectedHero.petitionLink && (
            <a
              className="petition"
              target="_blank"
              rel="noopener noreferrer"
              href={selectedHero.petitionLink}
            >
              {selectedHero.petitionText}
            </a>
          )}
          {selectedHero.Link && (
            <a
              className="petition"
              target="_blank"
              rel="noopener noreferrer"
              href={selectedHero.Link}
            >
              {selectedHero.LinkText}
            </a>
          )}
          {selectedHero.sliderImg && selectedHero.sliderImg.length > 0 && (
            <Slider sliderImages={selectedHero.sliderImg} />
          )}

          <GloryTemplate className="victim__glory" text="Вічна слава герою!" />

          <button
            type="button"
            className="victim__print-btn"
            onClick={() => window.print()}
          >
            <svg
              className="victim__print-icon"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M6 9V3h12v6" />
              <rect x="3" y="9" width="18" height="9" rx="2" />
              <rect x="7" y="14" width="10" height="7" rx="1" />
            </svg>
            Версія для друку
          </button>

          <Link className="social-btn" to="/">
            <Button
              className="help-btn"
              onClick={() => window.scrollTo(0, 0)}
              buttonText="Повернутись назад"
            />
          </Link>
        </div>
      </div>

      {/* ===== Скорочена версія для друку (видно лише при друку) ===== */}
      <div className="victim__print">
        <img className="victim__print-bg" src={printBg} alt="" />

        <p className="victim__print-community">
          Вільногірська територіальна громада
        </p>
        <p className="victim__print-motto">Герої не вмирають!</p>

        <img
          className="victim__print-photo"
          src={selectedHero.photo}
          alt={selectedHero.name}
        />

        <div className="victim__print-text">
          <h1 className="victim__print-name">
  <span className="victim__print-name-first">{firstLine}</span>{" "}
  {surname}
</h1>
          <p className="victim__print-date">{selectedHero.date}</p>
          <p className="victim__print-pos">{selectedHero.position}</p>
        </div>
      </div>
    </section>
  );
};

export default Page1;